import React from 'react';
import siteInfo from '../siteInfo';
import '../style/footer.css';

function Footer() {
  const year = new Date().getFullYear();
  const range = year > siteInfo.since ? `${siteInfo.since}–${year}` : `${year}`;

  return (
    <footer className="bb-footer">
      <div className="bb-footer__inner">
        <div className="bb-footer__brand-block">
          <span className="bb-footer__brand bb-display">{siteInfo.name}</span>
          <span className="bb-footer__tagline">{siteInfo.tagline}</span>
        </div>

        <span className="bb-footer__copy">
          © {range} {siteInfo.author}. Tous droits réservés.
        </span>

        <div className="bb-footer__right">
          {siteInfo.contactEmail && (
            <a className="bb-footer__link" href={`mailto:${siteInfo.contactEmail}`}>Contact</a>
          )}
          <span className="bb-footer__version bb-meta">v{siteInfo.version}</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
